import { useEntityStore } from '@/lib/sync/entity-store';
import type { RecordingMeta } from '@/lib/recordings/types/types';

/**
 * Subscribe to a single recording by id. Returns `undefined` when id is null
 * or the recording isn't in the store yet (e.g., the bootstrap UPSERTED event
 * for the recording hasn't arrived yet).
 *
 * Re-renders only when the specific row changes — the selector returns the
 * `RecordingMeta` reference directly, so Zustand's default `Object.is`
 * equality is sufficient (no `useShallow` needed).
 */
export function useRecording(id: string | null): RecordingMeta | undefined {
  return useEntityStore((s) => (id ? s.recordings.get(id) : undefined));
}
